import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component, ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges, ViewChild
} from '@angular/core';
import {
    ECriteria,
    IBookingCarbonFootprint, IFareFamilyDictionary,
    ICriteriaItem,
    IGetAirTripQuote,
    IGetAirTripQuotesDictionary, IJourneysRefAndAirRating,
    IQuote,
    ISegment
} from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { Yii } from "libraries/interfaces/Yii";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { IOutSelectQuote } from "app_locobook/pages/quote-page/components/quote-list-container/quote-list-container.component";
import {
    AllSegmentDialogComponent,
    IAllSegmentsDialogData
} from "app_locobook/shared/all-segment-dialog/all-segment-dialog.component";
import { ISegmentSelect } from "app_locobook/shared/segment-list/all-segment-list.component";
import { AirTripResourceService } from "libraries/service/resources/airTrip/airTripResource.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { forkJoin, Observable } from "rxjs";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { IOnAlternativeSelectOutput } from "app_locobook/pages/quote-page/components/fare-family-benchmark/fare-family-benchmark.component";
import { Router } from "@angular/router";
import { IqbaPathSegment } from 'app_locobook/iqba-paths';
import { LowCostCompanyService } from "../../service/low-cost-company.service";

export interface IBestQuotes {
    booking: {
        [bookingId: string]: IQuote;
    };
    criteriaArray: ICriteriaItem[];
}

enum EBestQuotesPermissionEnum {
    ratingYoucangoo = 'iqba.quote.rating.youcangoo.view',
    carbonFootprint = 'shared.air.carbonFootprint.show',
    cost = 'iqba.booking.price.cost.show',
    retail = 'iqba.booking.price.retail.show',
}

class WordingComponent {
    public readonly [ECriteria.carbonFootprint]:string = Yii.t('wui-iqba-js', 'La plus faible empreinte carbone');
    public readonly [ECriteria.duration]:string = Yii.t('wui-iqba-js', 'La plus rapide');
    public readonly [ECriteria.price]:string = Yii.t('wui-iqba-js', 'La moins chère');
    public readonly [ECriteria.rating]:string = Yii.t('wui-iqba-js', 'La mieux notée');
    public readonly [ECriteria.sort]:string = Yii.t('wui-iqba-js', 'Le choix IRWIGoo');
    public readonly showAlternativeFares: string = Yii.t('wui-iqba-js', 'Autres offres');
    public readonly hideAlternativeFares: string = Yii.t('wui-iqba-js', 'Masquer les autres offres');
}

class BestQuotesWording {
    public more: string = Yii.t('wui-iqba-js', 'Voir plus');
    public less: string = Yii.t('wui-iqba-js', 'Masquer');
    public close: string = Yii.t('wui-iqba-js', 'Fermer');
    public book: string = Yii.t('wui-iqba-js', 'Réserver');
    public select: string = Yii.t('wui-iqba-js', 'Voir');
    public modifySegment: string = Yii.t('wui-iqba-js', 'Ajouter');
    public bookTrip: string = Yii.t('wui-iqba-js', 'Réserver ce Voyage');
    public allSegments: string = Yii.t('wui-iqba-js', 'Tous les vols');
}

@Component({
    selector: 'best-quotes',
    template: `
        <div class="card-container {{colsNumber}}" *ngIf="bestQuotes">
            <!--        uncomment if we want to replace    -->
            <!--        <div class="card-container {{colsNumber}}" *ngIf="bestQuotes && !selectedCriteria">-->
            <card *ngFor="let criteria of bestQuotes.criteriaArray; let even = even" [class.even]="even"
                  class="e2e-best-quote-{{criteria.criteria}}">

                <div class="card-header-content">
                    {{wording[criteria.criteria]}}

                    <div class="btn-container">
                        <btn *ngIf="selectedCriteria !== criteria"
                             [type]="btnType.actionLink"
                             [label]="btnWording.more"
                             (onClick)="seeMore(criteria)">
                        </btn>
                        <btn *ngIf="selectedCriteria === criteria"
                             [type]="btnType.actionLink"
                             [label]="btnWording.less"
                             (onClick)="closeMore()">
                        </btn>
                        <btn *ngIf="showBookButton(bestQuotes.booking[criteria.bookingId], selectedJourneysByCriteria | mapGet: criteria.criteria)"
                             [type]="btnType.actionPrincipal"
                             [label]="getWording()"
                             (onClick)="book(criteria.bookingId)"></btn>
                    </div>
                </div>
                <div class="card-body-content">
                    <booking [key]="criteria.bookingId"
                             [bookingItem]="bestQuotes.booking[criteria.bookingId]"
                             [selectedJourneys]="selectedJourneysByCriteria | mapGet: criteria.criteria"
                             [fareFamilyDictionary]="dictionary.fareFamily"
                             [showAllActions]="false"
                             [originalRequest]="originalRequest"
                             [inline]="false"
                             [isInlineSegment]="this.colsNumber !== 'three-cols'"
                             [beginDaysDifference]="bestQuotes.booking[criteria.bookingId].beginDaysDifference">
                    </booking>
                </div>
            </card>
        </div>
        <card *ngIf="selectedCriteria && bestQuotes">
            <div class="card-header-content">
                {{wording[selectedCriteria.criteria]}}

                <div class="btn-container">
                    <btn [type]="btnType.actionLink"
                         [label]="btnWording.close"
                         (onClick)="closeMore()">
                    </btn>
                    <btn *ngIf="showBookButton(bestQuotes.booking[selectedCriteria.bookingId], selectedJourneysByCriteria | mapGet: selectedCriteria.criteria)"
                         [type]="btnType.actionPrincipal"
                         [label]="getWording()"
                         (click)="selectedFareFamilyOutput ? selectAlternative($event, selectedFareFamilyOutput): book(selectedCriteria.bookingId)"
                    (onClick)="book(selectedCriteria.bookingId)"></btn>
                </div>
            </div>
            <div class="card-body-content single" >
                <booking [key]="selectedCriteria.bookingId"
                         #container
                         [bookingItem]="bestQuotes.booking[selectedCriteria.bookingId]"
                         [selectedJourneys]="selectedJourneysByCriteria | mapGet: selectedCriteria.criteria"
                         [carriers]="dictionary.carrier"
                         [airports]="dictionary.airport"
                         [fareFamilyDictionary]="dictionary.fareFamily"
                         [originalRequest]="originalRequest"
                         [updateSelectedJourneyOnJourneyChange]="true"
                         [beginDaysDifference]="bestQuotes.booking[selectedCriteria.bookingId].beginDaysDifference">
                    <div class="booking-bottom">
                        <btn *ngIf="bestQuotes.booking[selectedCriteria.bookingId].segment | hasOtherSegments"
                             size="small"
                             class="othersFlights"
                             [label]="btnWording.allSegments"
                             type="actionLink"
                             classList="no-spacing"
                             (onClick)="openAllSegments(selectedCriteria.bookingId, selectedCriteria.criteria)"></btn>
                        <ng-container *permissionIf="offerAlternativesPermission; airQuote bestQuotes.booking[selectedCriteria.bookingId]">
                            <btn *ngIf="hasAlternativeFares"
                                 click-stop
                                 class="alternative-fares"
                                 [label]="isAlternativeFaresVisible ? wording.hideAlternativeFares : wording.showAlternativeFares"
                                 type="actionPrincipal"
                                 (onClick)="toggleAlternativeFares($event)">
                            </btn>
                        </ng-container>
                        

                    </div>
                </booking>
                <ng-container *ngIf="isAlternativeFaresVisible">
                    <fare-family-benchmark [sqaId]="tripId"
                                           [quoteId]="selectedCriteria.bookingId"
                                           [parentWidth]="containerWidth"
                                           [fareFamilyDictionary]="fareFamilyDictionary"
                                           [segments]="selectedSegments"
                                           [selectedJourneys]="selectedJourneys.get(selectedCriteria.bookingId)"
                                           (onAlternativeOpen)="setSelectedAlternative($event)"
                                           (onAlternativeSelect)="onAlternativeSelect.emit($event)"
                                           [sessionPostOnUpdateBooking]="sessionPostOnUpdateBooking"></fare-family-benchmark>
                </ng-container>
            </div>
        </card>
    `,
    styles: [`
        .card-container {
            display: flex;
        }

        .card-container.two-cols {
            flex-wrap: wrap;
        }

        .two-cols card {
            width: calc(50% - .375rem);
        }

        .two-cols card.even {
            margin-right: .75rem;
        }

        .three-cols card {
            width: calc(calc(100% / 3) - calc(.75rem * 2 / 3));
            margin-right: .75rem;
        }

        .three-cols card:nth-of-type(3) {
            margin-right: 0;
        }

        .card-body-content.single {
            padding-right: .75rem;
            padding-bottom: .75rem;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BestQuotesComponent implements OnChanges {
    @Input()
    public bestQuotes: IBestQuotes;
    @Input()
    public dictionary: IGetAirTripQuotesDictionary;
    @Input()
    public tripId: string;
    @Input()
    public originalRequest: any;
    @Input()
    public fareFamilyDictionary: { [key: string]: IFareFamilyDictionary };
    @Input()
    public isOfferSelection: boolean;
    @Input()
    public isModifySegment: boolean;
    @Input()
    public sessionPostOnUpdateBooking: any;

    @Output()
    public readonly onBook: EventEmitter<IOutSelectQuote> = new EventEmitter<IOutSelectQuote>();
    @Output()
    public readonly onAlternativeSelect: EventEmitter<IOnAlternativeSelectOutput> = new EventEmitter<IOnAlternativeSelectOutput>();

    @ViewChild('container')
    public readonly container: ElementRef;

    public selectedJourneys: Map<string, string[]> = new Map<string, string[]>();
    public selectedJourneysByCriteria: Map<string, string[]> = new Map<string, string[]>();
    public colsNumber: string;
    public readonly btnType: typeof BtnStyleTypes = BtnStyleTypes;
    public wording: WordingComponent = new WordingComponent();
    public readonly btnWording: BestQuotesWording = new BestQuotesWording();
    public selectedCriteria: ICriteriaItem;
    public readonly permissionList: typeof EBestQuotesPermissionEnum = EBestQuotesPermissionEnum;
    public hasAlternativeFares: boolean;
    public isAlternativeFaresVisible: boolean = false;
    public containerWidth: string;
    public selectedSegments: string[];
    public fareFamilyXId: string;
    public selectedFareFamilyOutput: IOnAlternativeSelectOutput;
    public offerAlternativesPermission: string = 'iqba.quote.offer.alternatives.use';

    constructor(
        protected readonly airTripResourceService: AirTripResourceService,
        protected readonly dialog: MatDialog,
        protected readonly changeDetector: ChangeDetectorRef,
        protected readonly permissionResourceService: PermissionResourceService,
        protected readonly router: Router,
        protected readonly lowCostCompanyService: LowCostCompanyService,
    ) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.bestQuotes && changes.bestQuotes.currentValue) {
            const bestQuotes: IBestQuotes = changes.bestQuotes.currentValue;
            this.selectedCriteria = null;

            const permissionObs: Array<Observable<boolean>> = Object.values(this.permissionList)
                .map((permissionPath: string) => {
                    return this.permissionResourceService.hasPermission(permissionPath);
                });

            forkJoin(permissionObs)
                .subscribe(
                    ([ratingYoucangoo, carbon, cost, retail]: [boolean, boolean, boolean, boolean]) => {

                        const canShowPrice: boolean = cost || retail;

                        //if one of permission is missing, then remove related criteria
                        if (!ratingYoucangoo || !carbon || (!canShowPrice)) {
                            bestQuotes.criteriaArray = bestQuotes.criteriaArray.filter(
                                (criteria: ICriteriaItem) => {
                                    return ((criteria.criteria === ECriteria.carbonFootprint) && carbon) ||
                                        ((criteria.criteria === ECriteria.rating) && ratingYoucangoo) ||
                                        ((criteria.criteria === ECriteria.price) && canShowPrice) ||
                                        (criteria.criteria === ECriteria.duration);
                                });
                        }

                        this.colsNumber = bestQuotes && bestQuotes.criteriaArray.length % 2 === 0 ?
                            "two-cols" :
                            "three-cols";
                        Object.keys(bestQuotes.booking).forEach(
                            (bookingId: string) => {

                                const journeys: string[] = Object.values(this.bestQuotes.booking[bookingId].segment)
                                    .map((segment: ISegment) => segment.journey[0]);

                                this.selectedJourneys.set(
                                    bookingId,
                                    journeys,
                                );
                            }
                        );

                        Object.values(bestQuotes.criteriaArray)
                            .forEach((criteriaItem: ICriteriaItem) => {
                                let journeys: string[] = Object.values(this.bestQuotes.booking[criteriaItem.bookingId].segment)
                                    .map((segment: ISegment) => segment.journey[0]);
                                switch (criteriaItem.criteria) {
                                    case ECriteria.rating:
                                        if(this.bestQuotes.booking[criteriaItem.bookingId] && this.bestQuotes.booking[criteriaItem.bookingId].ratingArray?.length){
                                            journeys = this.bestQuotes.booking[criteriaItem.bookingId]
                                                .ratingArray
                                                .sort((aRating: IJourneysRefAndAirRating, bRating: IJourneysRefAndAirRating): number => {
                                                    return bRating.rating.value - aRating.rating.value;
                                                })[0]
                                                .journeyIds;
                                        }
                                        break;
                                    case ECriteria.carbonFootprint:
                                        if(this.bestQuotes.booking[criteriaItem.bookingId] && this.bestQuotes.booking[criteriaItem.bookingId].carbonFootprintArray){
                                            journeys = this.bestQuotes.booking[criteriaItem.bookingId]
                                                .carbonFootprintArray
                                                .sort((aCarbonFootprint: IBookingCarbonFootprint, bCarbonFootprint: IBookingCarbonFootprint) => {
                                                    return aCarbonFootprint.carbonFootprint.value - bCarbonFootprint.carbonFootprint.value;
                                                })[0]
                                                .journeyIds;
                                        }
                                        break;
                                    case ECriteria.duration:
                                    case ECriteria.price:
                                    default:
                                        break;

                                }
                                this.selectedJourneysByCriteria.set(
                                    criteriaItem.criteria,
                                    journeys,
                                );
                            });
                    }
                );
        }
    }

    public async selectAlternative($event: MouseEvent, selectedAlternativeOutput: IOnAlternativeSelectOutput): Promise<void> {
        event.stopPropagation();
        await this.router
            .navigate([
                IqbaPathSegment.Locobook,
                IqbaPathSegment.Search,
                this.tripId,
                this.selectedCriteria.bookingId,
                IqbaPathSegment.Alternative,
                selectedAlternativeOutput.offerAlternativePriceXId])
            .then((): void => {
                this.onAlternativeSelect.emit(selectedAlternativeOutput);
            });
    }

    public book(quoteId: string): void {
        this.onBook.emit({quoteId, selectedJourneys: this.selectedJourneys.get(quoteId)});
    }

    public seeMore(criteria: ICriteriaItem): void {
        this.isAlternativeFaresVisible = false;
        this.selectedCriteria = criteria;
        this.hasAlternativeFaresChecking();
        this.computeSelectedSegments();
        this.setFareFamilyXid();
    }

    public closeMore(): void {
        this.selectedCriteria = null;
        this.isAlternativeFaresVisible = false;
    }

    public openAllSegments(bookingId: string, criteria: ECriteria): void {
        //avoid select quote
        this.airTripResourceService.getQuote(this.tripId, bookingId)
            .subscribe((quote: IGetAirTripQuote) => {
                const data: IAllSegmentsDialogData = {
                    quoteId: bookingId,
                    segmentList: quote.booking[bookingId].segment,
                    selectedSegment: this.selectedJourneysByCriteria.get(criteria),
                };
                const dialog: MatDialogRef<AllSegmentDialogComponent, ISegmentSelect> = this.dialog
                    .open(AllSegmentDialogComponent, {
                        data,
                    });
                dialog
                    .afterClosed()
                    .subscribe((selectedSegmentInfo: ISegmentSelect) => {
                        if (selectedSegmentInfo) {
                            this.selectedJourneysByCriteria.set(criteria, selectedSegmentInfo.selectedSegment);
                            this.selectedJourneysByCriteria = new Map<string, string[]>(this.selectedJourneysByCriteria);
                            this.changeDetector.markForCheck();
                        }
                    });
            });
    }

    public toggleAlternativeFares(event: Event): void {
        event.stopPropagation();
        this.containerWidth = `${this.container?.nativeElement?.offsetWidth}px`;
        this.isAlternativeFaresVisible = !this.isAlternativeFaresVisible;
    }

    public setSelectedAlternative($event: IOnAlternativeSelectOutput): void {
        this.selectedFareFamilyOutput = $event;
    }

    private hasAlternativeFaresChecking(): void {
        const booking: IQuote = this.bestQuotes.booking[this.selectedCriteria.bookingId];
        this.hasAlternativeFares = Boolean(booking.fareFamily);
    }
    private computeSelectedSegments(): void {
        const booking: IQuote = this.bestQuotes.booking[this.selectedCriteria.bookingId];
        this.selectedSegments = Object.keys(booking.segment);
    }
    private setFareFamilyXid(): void {
        if (this.hasAlternativeFares) {
            const booking: IQuote = this.bestQuotes.booking[this.selectedCriteria.bookingId];
            this.fareFamilyXId = Object.keys(booking.fareFamily).length > 0 ? Object.keys(booking.fareFamily)[0] : null;
        }
    }

    public getWording(): string{
        if(this.isOfferSelection){
            return this.btnWording.select;
        }

        if(this.isModifySegment){
            return this.btnWording.modifySegment;
        }

        return this.btnWording.book;
    }

    public showBookButton(quote: IQuote, selectedJourneys: string[]): boolean {
        if(!this.isModifySegment){
            return true;
        }

        return !this.lowCostCompanyService.hasLcc(quote, selectedJourneys);
    }

}
